var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"places-dtm"},_vm._l((_vm.places),function(place){return _c('div',{key:place.cluster_id,staticClass:"place-btn"},[_c('NcButton',{staticClass:"place",attrs:{"to":_vm.route(place)}},[_vm._v(_vm._s(place.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }